import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Title } from "@bw/bits"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  display: grid;
  grid-gap: 32px;

  > .shadow {
    &:after {
      content: "";
      width: 60%;
      height: 50px;
      margin: 0 auto;
      z-index: 1;
      transform: translate(0, -25px);
      background: linear-gradient(
        239.97deg,
        rgba(96, 200, 233, 0.16) 24.3%,
        rgba(71, 118, 189, 0.26) 55.26%,
        rgba(96, 159, 233, 0.11) 96.78%
      );
      opacity: 0.65;
      filter: blur(40px);
      border-radius: 14px;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr 1fr;

    > * {
      align-self: center;
    }
  }
`

const InversedText = styled.div`
  @media (min-width: ${breakpoints.medium}px) {
    grid-row: 1 / 2;
    grid-column: 2 / 3;
  }
`

const InversedImage = styled.div`
  &:after {
    content: "";
    width: 60%;
    height: 50px;
    margin: 0 auto;
    z-index: 1;
    transform: translate(0, -25px);
    background: linear-gradient(
      239.97deg,
      rgba(96, 200, 233, 0.16) 24.3%,
      rgba(71, 118, 189, 0.26) 55.26%,
      rgba(96, 159, 233, 0.11) 96.78%
    );
    opacity: 0.65;
    filter: blur(40px);
    border-radius: 14px;
  }
  @media (min-width: ${breakpoints.medium}px) {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.$justify === "center" ? "center" : `flex-${props.$justify}`};
  margin-top: 45px;
`

const ContentWithImage = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  text,
  image,
  orientation,
}) => {
  const content = (
    <>
      {(suptitle || title) && <Title {...{ suptitle, title, subtitle }} />}
      {text}
      {button && (
        <ButtonWrapper $justify={buttonPosition}>{button}</ButtonWrapper>
      )}
    </>
  )
  if (orientation === "text_on_left") {
    return (
      <Wrapper>
        <div>{content}</div>
        <div className="shadow">{image}</div>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <InversedText>{content}</InversedText>
      <InversedImage>{image}</InversedImage>
    </Wrapper>
  )
}

ContentWithImage.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.any,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  orientation: PropTypes.oneOf(["fullpage", "text_on_left", "text_on_right"]),
  button: PropTypes.element,
  buttonPosition: PropTypes.oneOf(["start", "center", "end"]),
}

ContentWithImage.defaultProps = {
  orientation: "text_on_left",
}

export { ContentWithImage }
